import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  FormLabel,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import React, { useState } from "react";

export default function ConfirmPasswordField({
  confirmPassword,
  setConfirmPassword,
  password, // Tambahkan password untuk validasi
  error,
  errorMessage,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl>
      <FormLabel htmlFor="confirm-password">Confirm Password</FormLabel>
      <TextField
        required
        fullWidth
        id="confirm-password"
        placeholder="••••••"
        type={showPassword ? "text" : "password"}
        autoComplete="off"
        variant="outlined"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        error={!!error}
        helperText={error}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
}
